import script from "./QueryServiceAreasView.vue?vue&type=script&setup=true&lang=js"
export * from "./QueryServiceAreasView.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__